import { FC } from 'react'
import cn from 'classnames'
import styles from 'components/features/pfm/ProviderSearchPane/ProviderSearchPane.styl'
import { Provider } from 'interfaces/linkage'
import { getTextMatches } from 'helpers/formatHelpers'
import { getProviderLogoPath } from 'helpers/linkageHelpers'

type ResultItemProps = {
  provider: Provider
  query: string
  onClick: () => void
  isHighlighted: boolean
}
export const ResultItem: FC<ResultItemProps> = (props) => {
  const { provider, onClick, query, isHighlighted } = props

  const nameParts = getTextMatches(provider.name, query)
  const logoPath = getProviderLogoPath(provider.name)

  return (
    <li
      className={ cn(styles.resultItem, { [styles.isHighlighted]: isHighlighted }) }
      key={ provider.cid }
      data-qa-type='result-item'
      onClick={ onClick }
    >
      <div
        className={ styles.resultItemIcon }
        style={{ backgroundImage: `url(${ logoPath || provider.logo })` }}
      />
      <div className={ styles.resultItemText }>
        {
          nameParts.map((part, idx) => {
            const partClassName = part.isMatch ? styles.resultItemTextHighlighted : undefined

            return (
              <span key={ idx } className={ partClassName }>{ part.chunk }</span>
            )
          })
        }
      </div>
    </li>
  )
}
